import { useRef } from "react";

export function useAudio() {
  const audioCtxRef = useRef(null);
  const sourceRef = useRef(null);

  async function play(url, onEnded) {

    if (!audioCtxRef.current) {
      // 샘플레이트를 명시적으로 48kHz로 설정 (지원 안되면 기본값 사용)
      try {
        audioCtxRef.current = new (window.AudioContext ||
          window.webkitAudioContext)({ sampleRate: 44100 });
        // window.webkitAudioContext)({ sampleRate: 48000 });
      } catch {
        audioCtxRef.current = new (window.AudioContext ||
          window.webkitAudioContext)();
      }
    }
    const audioCtx = audioCtxRef.current;

    // iOS WebView 대응: 반드시 resume() 먼저 (유저 제스처 안에서 보장)
    if (audioCtx.state === "suspended") {
      try {
        await audioCtx.resume();
      } catch (e) {
        console.warn("AudioContext resume failed:", e);
      }
    }

    // 이전 소스 정리
    if (sourceRef.current) {
      sourceRef.current.stop();
      sourceRef.current.disconnect();
    }

    console.log('url2222', url)


    // 오디오 파일 fetch
    const response = await fetch(url);
    const arrayBuffer = await response.arrayBuffer();
    const audioBuffer = await audioCtx.decodeAudioData(arrayBuffer);

    // 소스 생성
    const source = audioCtx.createBufferSource();
    source.buffer = audioBuffer;

    // EQ 필터 (저음 + 고음 보정)
    const bass = audioCtx.createBiquadFilter();
    bass.type = "lowshelf";
    bass.frequency.value = 200;
    bass.gain.value = 2;

    const treble = audioCtx.createBiquadFilter();
    treble.type = "highshelf";
    treble.frequency.value = 3000;
    treble.gain.value = 2;

    // Compressor (음량 균일화 & 음질 안정화)
    const compressor = audioCtx.createDynamicsCompressor();
    compressor.threshold.value = -24;
    compressor.knee.value = 30;
    compressor.ratio.value = 12;
    compressor.attack.value = 0.003;
    compressor.release.value = 0.25;

    // Gain Node (볼륨 보정)
    const gainNode = audioCtx.createGain();
    // gainNode.gain.value = 1.15;

    // 체인 연결: source → bass → treble → compressor → gain → destination
    source
    .connect(bass)
    .connect(treble)
    .connect(compressor)
    .connect(gainNode)
    .connect(audioCtx.destination);

    // 종료 이벤트 핸들러
    source.onended = () => {
      if (typeof onEnded === "function") {
        onEnded();
      }
      source.disconnect();
      sourceRef.current = null;
    };

    source.start();
    sourceRef.current = source;
  }

  function stop() {
    if (sourceRef.current) {
      sourceRef.current.stop();
      sourceRef.current.disconnect();
      sourceRef.current = null;
    }
  }

  return { play, stop };
}
